// src/api/approver.js
import request from './base/request';

const approver_api = {
  // Fetch courts that are pending approval
  get_pending_courts: async () => {
    try {
      const response = await request.get('/approver/courts/pending', true);
      return response;
    } catch (error) {
      console.error('[Approver API] Error in get_pending_courts:', error);
      throw error;
    }
  },

  // Approve a specific court by ID
  approve_court: async (courtId) => {
    try {
      const response = await request.patch(`/approver/courts/${courtId}/approve`, {}, true);
      return response;
    } catch (error) {
      console.error('[Approver API] Error in approve_court:', error);
      throw error;
    }
  },

  // Reject a specific court by ID with optional notes
  reject_court: async (courtId, reason) => {
    try {
      const payload = reason ? { reason } : {};
      const response = await request.patch(`/approver/courts/${courtId}/reject`, payload, true);
      return response;
    } catch (error) {
      console.error('[Approver API] Error in reject_court:', error);
      throw error;
    }
  }
};

export default approver_api;
